import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'

export const identityValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const certificateId = control.get('certificateId') || { value: null }
    const tattooId = control.get('tattooId') || { value: null }
    const rfid = control.get('rfid') || { value: null }
    return !certificateId.value && !tattooId.value && !rfid.value ? { atLeastOne: true } : null
}
